import React from 'react';

const TONES = [
  { id: 'professional', label: 'Professional', icon: '💼', color: '#3b82f6' },
  { id: 'warm', label: 'Warm', icon: '🤝', color: '#f59e0b' },
  { id: 'assertive', label: 'Assertive', icon: '💪', color: '#ef4444' },
  { id: 'casual', label: 'Casual', icon: '😊', color: '#22c55e' },
  { id: 'diplomatic', label: 'Diplomatic', icon: '🕊️', color: '#8b5cf6' }
];

export default function ToneSelector({ selected, onChange }) {
  const toggle = (toneId) => {
    if (selected.includes(toneId)) {
      if (selected.length > 1) onChange(selected.filter(t => t !== toneId));
    } else {
      onChange([...selected, toneId]);
    }
  };

  return (
    <div style={styles.container}>
      <span style={styles.label}>Tones:</span>
      <div style={styles.tones}>
        {TONES.map(tone => (
          <button
            key={tone.id}
            onClick={() => toggle(tone.id)}
            style={{
              ...styles.toneBtn,
              ...(selected.includes(tone.id) ? { background: tone.color + '22', borderColor: tone.color, color: tone.color } : {})
            }}
          >
            <span>{tone.icon}</span>
            <span>{tone.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' },
  label: { fontSize: 13, color: 'var(--text-muted)', fontWeight: 500 },
  tones: { display: 'flex', gap: 6, flexWrap: 'wrap' },
  toneBtn: {
    display: 'flex', alignItems: 'center', gap: 4, padding: '6px 12px',
    background: 'var(--bg-primary)', border: '1px solid var(--border)', borderRadius: 20,
    color: 'var(--text-secondary)', fontSize: 13, cursor: 'pointer', transition: 'all 0.2s',
    whiteSpace: 'nowrap'
  }
};
